<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconRaiseHand_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M20.34 9.262a1.193 1.193 0 0 0-1.468.832l-.955 3.449-1.15-.318 1.909-6.899a1.194 1.194 0 0 0-2.3-.636l-1.909 6.899-1.15-.318 2.228-8.049a1.193 1.193 0 0 0-2.3-.636l-2.227 8.047-1.15-.318 1.909-6.899a1.193 1.193 0 0 0-2.299-.636l-2.65 9.575c-.14.507-.819.509-.936-.004a141.62 141.62 0 0 1-.579-2.961 1.21 1.21 0 0 0-2.397.225c.004.916.019 2.28.069 3.419.195 4.44 4.573 6.493 6.696 7.081 2.618.724 5.146.809 7.055-.408 1.314-.838 2.353-2.452 2.852-4.254l1.584-5.723a1.193 1.193 0 0 0-.832-1.468Z"
    />
</svg>
